<h1>Login</h1>

<section id="login">
    <p><label>User Name:</label><input (keyup.enter)="checkPw()" [(ngModel)]="username">
    <p><label>Password:</label><input (keyup.enter)="checkPw()" type="password" [(ngModel)]="password">
    <p class="warning">{{message}}</p>
    <p><button (click)="checkPw()">Log In</button>
</section>
